import React from 'react';
import styled from 'styled-components';

import { FONT } from '../../styles/color';
import { Medium } from './Text';

const Wrapper = styled.button`
    width: ${ props => props.width };
    height: ${ props => props.height };
    border: none;
    border-radius: 8px;
    background-color: ${ FONT.default  };
    color: ${ FONT.light01 };
`;

export default function Button(props) {
    return (
        <Wrapper
            style={ props.style }
            onClick={ props.onClick }
            width={ props.width ? props.width : '320px' }
            height={ props.height ? props.height : '70px' }
        >
            <Medium size={props.textSize ? props.textSize : "24px"} color={ FONT.light01 } >{ props.buttonText }</Medium>
        </Wrapper>
    );
}
